import { QueryClient } from '@tanstack/vue-query'

const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

export default appQueryClient
